import qs from "qs";
import axios from "../helpers/axios";

import {
  LedgerActivityItem,
  LedgerActivityResult,
  LedgerActivitySearchQuery,
  LedgerBalance,
} from "../types/ledgerActivity";

type GetLedgerActivityQuery = {
  page: number;
  pageSize: number;
  searchQuery: LedgerActivitySearchQuery;
};

const DEFAULT_HOLD_STATUSES = "PENDING";

export const getLedgerActivity = async ({
  page,
  pageSize,
  searchQuery,
}: GetLedgerActivityQuery): Promise<LedgerActivityResult> => {
  const params = {
    currency: searchQuery.currency,
    start: searchQuery.start,
    end: searchQuery.end,
    kinds: searchQuery.kinds,
    holdStatuses: searchQuery.holdStatuses ?? DEFAULT_HOLD_STATUSES,
    limit: pageSize + 1,
    offset: page * pageSize,
  };

  const { data } = await axios.get<LedgerActivityItem[]>(
    `/admin/ledger/accounts/${encodeURIComponent(searchQuery.userId)}/activity`,
    {
      params,
      paramsSerializer: (p) => qs.stringify(p, { skipNulls: true }),
    }
  );

  const fetched = Array.isArray(data) ? data : [];
  const hasMore = fetched.length > pageSize;

  return {
    items: hasMore ? fetched.slice(0, pageSize) : fetched,
    pageSize,
    hasMore,
  };
};

export const getLedgerBalance = async (
  userId: string,
  currency: LedgerActivitySearchQuery["currency"]
): Promise<LedgerBalance> => {
  const { data } = await axios.get<LedgerBalance>(
    `/admin/ledger/accounts/${encodeURIComponent(userId)}/balance`,
    { params: { currency } }
  );
  return data;
};
